/* eslint-disable import/prefer-default-export */
export const mainMenu = [
  {
    link: '/payments/',
    title: 'できること',
  },
  {
    link: '/shop/',
    title: '使えるお店',
    subMenu: [
      {
        link: '/shop/',
        title: 'お店紹介',
      },
      {
        link: '/shop/list/',
        title: 'お店一覧',
      },
    ],
  },
  {
    link: '/company/',
    title: '会社プロフィール',
  },
  {
    link: '/media_center/',
    rootLink: true,
    title: 'メディアセンター',
    witActiveSubMenu: true,
    subMenu: [
      {
        link: '/media_center/',
        rootLink: true,
        title: 'メディアセンター',
      },
      {
        link: '/media_center/fun/',
        title: 'Paidyファン',
      },
      {
        link: '/media_center/press/',
        title: 'Paidyプレス',
      },
      {
        link: '/media_center/work_life/',
        title: 'Paidyワーク＆ライフ',
      },
    ],
  },
];

export const merchantMenu = [
  {
    link: '/merchant/',
    title: 'トップ',
  },
  {
    link: '/merchant/industry',
    title: '業種別の使い方',
    subMenu: [
      {
        link: '/merchant/industry/goods/',
        title: '物販',
      },
      {
        link: '/merchant/industry/digital/',
        title: 'デジタルコンテンツ',
      },
      {
        link: '/merchant/industry/travel/',
        title: 'トラベル・アクティビティ',
      },
      {
        link: '/merchant/industry/subscription/',
        title: 'サブスクリプション',
      },
    ],
  },
  {
    link: '/merchant/application/',
    title: '導入の流れ',
  },
  {
    link: '/merchant/case_study/',
    followLink: '/merchant/case/',
    title: '導入事例',
  },
  {
    link: '/merchant/materials/',
    title: '各種資料',
    subMenu: [
      // {
      //   link: '/merchant/materials/white_paper/',
      //   title: 'お役立ち情報',
      // },
      {
        link: '/merchant/materials/sales/',
        title: '資料請求',
      },
      {
        extLink: 'https://paidy.com/docs/jp/',
        title: '開発向けドキュメント',
      },
      {
        link: '/merchant/materials/faq/',
        title: 'よくあるご質問',
      },
    ],
  },
];

export const tabletMerchantMenu = [].concat(merchantMenu);
tabletMerchantMenu.splice(1, 0, {
  extLink: 'https://my.paidy.com/login/',
  title: 'ログイン',
});
